import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';

import { createFormsFailure, createFormsSuccess } from '../actions';
import FormsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { FORM_API_BASE_URL } = urls || {};

function* createForm({ payload: { data, cb } }) {
  const url = `${FORM_API_BASE_URL}/designs`;

  const response = yield request({
    method: 'post',
    data,
    url,
  });
  if (response.success) {
    Notify(`Form Created Successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    yield cb(response.raw?.id);
    yield put(createFormsSuccess(response.raw));
  } else {
    yield put(createFormsFailure(response.message));
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onFormCreate() {
  yield takeLatest(FormsActionTypes.START_CREATE_FORM, createForm);
}
